import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '@config/api.config';
import {INSTITUTE_SERVICE, INSTITUTE_SERVICE_API_VERSION} from '@constants/api.constants';
import {InstituteEnumData} from '@core/models/enum.model';
import {ApiResponse} from '@core/models/api-response.model';
import {endpoint} from '@constants/path.constants';


@Injectable({providedIn: 'root'})
export class InstituteWebservices {
  private readonly baseUrl = ApiConfig.getBaseUrl(INSTITUTE_SERVICE, INSTITUTE_SERVICE_API_VERSION);
  private _instituteToken: string = "";

  constructor(private http: HttpClient) {
  }

  set setInstituteToken(value: string) {
    this._instituteToken = value;
  }

  getInstituteEnum() {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.get<ApiResponse<InstituteEnumData>>(
      this.baseUrl + endpoint.institute.enum, {headers}
    );
  }

  verifyInstitute(payload: {}) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.institute.verify_institute, payload, {headers}
    );
  }
}
